import { t } from "@lingui/macro";

import { InfoBanner } from "@whoosh/design-system/src/components/display/InfoBanner";

export const CancelBookingModification = () => {
  return (
    <InfoBanner
      message={t`Access to make modifications to this booking is no longer available. If you have any questions please reach out to the club house.`}
      colorTheme="WARNING"
      type="CARD"
    />
  );
};
